// LoginRequired.js
export default function LoginRequired() {
    return (
        <div className="container mt-5">
            <div className="alert alert-warning text-center">
                🔒 กรุณาเข้าสู่ระบบก่อนใช้งานหน้านี้
            </div>
        </div>
    );
}
